import App from './App.vue';
import { loadEventData, mountApp, waitForXMidas, loadXMidasSdk, loadPaymentApi } from '@/utils/init';

Promise.all([loadEventData(), loadXMidasSdk(), loadPaymentApi()])
  .then(() => waitForXMidas())
  .then(() => mountApp(App));
